module.exports = __webpack_public_path__ + "static/img/examineFB.1259d47.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/examineFB.png
// module id = C8dP
// module chunks = 7